<template>
  <div id="app">
    <router-view name="HeaderBg" />
    <router-view />
  </div>
</template>

<script>
import DarkMode from 'darkmode-js';

const darkmode = new DarkMode({
  backgroundColor: '#e4d28b', // ##1f337f
});
if (!darkmode.isActivated()) {
  darkmode.toggle();
}

export default {
  name: "App",
};
</script>

<style lang="less">
// @import './dark.less';
</style>



// WEBPACK FOOTER //
// src/App.vue